import { Grid, Skeleton } from '@mui/material'
import React from 'react'

function HorsesLoaderSkeleton() {
    return (
        <Grid container spacing={2}>
            {[...Array(15)].map((e, i) => (
                <Grid item key={i} md={4} sm={6} xs={12}>
                    <Skeleton variant='rectangular' width={'100%'} height={110} sx={{borderRadius:2}}></Skeleton>
                </Grid>
            ))}
        </Grid>
    )
}

export default HorsesLoaderSkeleton